import { env } from '@/env';
import { Crisp } from 'crisp-sdk-web';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useCrisp() {
  const location = useLocation();

  useEffect(() => {
    const crispWebsiteId = env.VITE_CRISP_WEBSITE_ID;

    if (crispWebsiteId) {
      // Configure Crisp
      Crisp.configure(crispWebsiteId);

      // Check if current path matches tenant-specific routes (excluding admin routes)
      const isTenantRoute =
        /^\/o\/[^/]+\/.*$/.test(location.pathname) &&
        !location.pathname.startsWith('/o/admin/');

      if (isTenantRoute) {
        // Show Crisp on tenant-specific pages
        Crisp.chat.show();
      } else {
        // Hide Crisp on all other pages
        Crisp.chat.hide();
      }
    }
  }, [location.pathname]);
}
